import React, { useContext, useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../assets/Maersk_Logo_RGB.svg";
import "../App.css";
import { TableContext } from "../context";
import IconButton from '@mui/material/IconButton';
import NotificationsIcon from '@mui/icons-material/Notifications';
import Badge from '@mui/material/Badge';
import { FaUser, FaChevronDown } from "react-icons/fa";
import { McMenu } from "@maersk-global/mds-react-wrapper/components-core/mc-menu";
import { McButton } from "@maersk-global/mds-react-wrapper/components-core/mc-button";
import { McList } from "@maersk-global/mds-react-wrapper/components-core/mc-list";
import { McListItem } from "@maersk-global/mds-react-wrapper/components-core/mc-list-item";
/**
 * Navbar component for displaying the navigation bar.
 * Includes the company logo, portal link, and user profile information.
 */
function Navbar() {
  const { graphData, handleLogout, notificationCount, setSearch, userRole } = useContext(TableContext);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const navigate = useNavigate();

  const handleMySubscriptionsClick = () => {
    setIsProfileOpen(false);
    navigate('/subscription-management');
  };

  const handleChangesClick = () => {
    setSearch('');
  };
  const profileRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setIsProfileOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div>
      <nav className="navbar">
        <div className="nav-bar" style={{ padding: "0 1rem"}}>
          <div className="nav-container">
            <img 
              src={Logo} 
              alt="Logo"
              height="55"
              width="120"
              style={{ marginTop: "5px" }} 
            />
        <McMenu trigger="click" className="more-dropdown">
          <McButton slot="trigger" label="Flux"
            appearance="neutral" variant="plain" trailingicon="chevron-down"><span className="logo-navLogo" style={{ fontSize: "1.2rem", fontWeight: "500", color: "#333" }}>
              Flux
            </span></McButton>
          <McList >
            <McListItem href={process.env.REACT_APP_MSA_LINK} target="blank" trailingicon = "square-arrow-up-right">MSA</McListItem>
          </McList>
        </McMenu>
            <div className="menu">
              <ul className="nav-links">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/Changes" onClick={handleChangesClick}>Changes</Link>
                </li>
                <li>
                  <Link to="/TestResults">Test Results</Link>
                </li>
                <li>
                  <Link to="/application-onboarding">Change Onboarding</Link>
                </li>
                <li>
                  <Link to="/RedGreenChannelTracker">Red/Green Channel</Link>
                </li>
                {userRole === 'admin' || userRole === 'change manager' ? (
                  <li>
                    <Link to="/P1P2Incidents" onClick={handleChangesClick}>P1/P2 Incidents</Link>
                  </li>
                ) : null}
              </ul>
            </div>
          </div>
          <div style={{display: "flex", flexDirection: "row"}}>
            <Link to="/Subscriptions?tab=NotificationCenter">
              <IconButton aria-label="notification" style={{marginRight: "10px"}}>
              <Badge badgeContent={notificationCount} color="error">
                <NotificationsIcon sx={{ color: '#555', '&:hover': { color: '#0078d4' } }}/>
              </Badge>
              </IconButton>
            </Link>
            <div className="profile-dropdown" ref={profileRef}>
              <button onClick={() => setIsProfileOpen(!isProfileOpen)} className="profile-button" aria-label="Profile menu">
                <FaUser className="profile-icon" />
                <span className="profile-text">{graphData?.displayName?.split(" ")[0]}</span>
              </button>

              {isProfileOpen && (
                  <ul className="dropdown-menu profile-menu">
                      <li>
                          <a href="#" onClick={(e) => { e.preventDefault(); handleMySubscriptionsClick(); }}>
                              Manage Subscriptions
                          </a>
                      </li>
                      <li>
                          <a href="#" onClick={handleLogout}>
                              Logout
                          </a>
                      </li>
                  </ul>
              )}
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Navbar;